import { BeStack, BeTextControl, BeTextView } from "@beos-css/react/index.ts";

export function TextFieldDemo() {
	return (
		<section id="demo-text">
			<h2>Text field (BTextControl / BTextView)</h2>
			<p>
				The sunken white well; focus turns the inner ring nav-blue. The text is a native input/textarea (the browser is the text engine).
			</p>
			<BeStack gap="label" align="start">
				<BeTextControl label="Name:" defaultValue="Untitled" />
				<BeTextControl label="Focused:" defaultValue="Nav-blue ring" className="is-focus" />
				<BeTextControl label="Disabled:" defaultValue="Read only" disabled />
				<BeTextView defaultValue={"A multi-line\nBTextView."} rows={3} />
				<div className="be-text-field be-text-field--multiline">
					<div className="be-text-field__input demo-narrow">
						<strong>Rich content host:</strong> the well classes work on any element, not just a textarea.
					</div>
				</div>
			</BeStack>
		</section>
	);
}
